<template>
    <div id="wrapper">
        <div id="viewerContainer" class="container">
            <div class="row">
                <div class="col-xs-12">
                    <div class="text-center whiteText">
                        <div v-if="showLoader" style="margin-top: 40%">
                            <img class="responsive" src="../../assets/ms_loading_white.svg" style="max-width: 100px;">
                            <p>
                                <strong>{{ $t('pages.viewer.pictureontheway') }}</strong>
                            </p>
                        </div>
                        <email-capture-box v-show="showEmailCaptureBox"></email-capture-box>

                        <viewer-image :original-url="originalUrl" :gif-url="gifUrl" :boomerang-url="boomerangUrl"
                                      :Parms="$route.params" :checksum="checksum" :show-image="showImage">
                        </viewer-image>


                        <div class="col-xs-2" v-if="showImageNoShow" style="margin-top: 40%">
                            <strong>
                                {{ $t('pages.viewer.nopicture') }}
                            </strong>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 text-center" v-if="showOneDayButton">
                    <b-button variant="primary"
                              class="btn rounded-pill d-flex justify-content-center align-items-center position-relative btn-block btn-primary"
                              :href="oneDayGalleryUrl" target="_blank">
                        {{ $t('pages.viewer.seegallery') }}
                    </b-button>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import APIService from '../../services/APIService';
    import ViewerImage from "@/components/ViewerImage";
    import EmailCaptureBox from "@/components/EmailCaptureBox";
    import { sleep } from '@/GeneralMethods'

    export default {
        components: { EmailCaptureBox, ViewerImage },
        data() {
            return {
                oneDayGalleryUrl: null,
                originalUrl: '',
                gifUrl: '',
                boomerangUrl: '',
                checksum: '',
                retryCount: 0,
                maxRetries: 8,
                deviceNumber: 0,
                initialRetryDelay: 2000,
                delayIncrement: 500,
                pollingEnabled: true,
                imageAccessible: true,
                layout: {
                    waitForImageElapsed: false,
                    buttonLoading: false,
                    loading: false,
                    showPicture: false
                }
            }
        },
        watch: {
            $route() {
                location.reload();
            }
        },
        computed: {
            originalImageAvailable() {
                return this.originalUrl !== null && this.originalUrl !== '' && this.imageAccessible;
            },
            gifAvailable() {
                return this.gifUrl !== null && this.gifUrl !== '' && this.imageAccessible;
            },
            boomerangAvailable() {
                return this.boomerangUrl !== null && this.boomerangUrl !== '' && this.imageAccessible;
            },
            showImageNoShow() {
                return !this.showEmailCaptureBox && !this.showLoader && this.originalUrl === '';
            },
            showImage() {
                return !this.showLoader && this.layout.showPicture;
            },
            showLoader() {
                return this.layout.loading && !this.showEmailCaptureBox;
            },
            showOneDayButton() {
                return this.$route.params.onedaybutton && this.oneDayGalleryUrl && this.showImage;
            },
            showEmailCaptureBox() {
                return this.connectionState === 0 || this.layout.waitForImageElapsed;
            },
            connectionState() {
                return this.$route.params.connectionState;
            },
            getOnedayEndpoint() {
                const params = this.$route.params;
                return `/sharing/onedaylink/${params.domain}/${params.order}/${params.file}/${params.type}/${params.onedaybutton}/${params.connectionState}/${this.checksum}`
            }
        },
        methods: {
            async loadImage(selectedType = null) {
                const params = this.$route.params;
                this.deviceNumber = this.getDeviceNumberFromFileName(params.file)
                const type = selectedType ?? params.type
                const imageEndpoint = `/sharing/image/${params.domain}/${params.order}/${params.file}/${type}/${params.onedaybutton}/${params.connectionState}/${this.checksum}`
                let result = ''

                if (selectedType !== null) {
                    const response = await APIService.GET(imageEndpoint)
                    if (response.ok) {
                        result = await response.text();
                    }
                    return result
                }

                while (this.retryCount < this.maxRetries) {
                    this.layout.loading = true;
                    const response = await APIService.GET(imageEndpoint)
                    const status = response.status;
                    switch (status) {
                        case 200:
                            result = await response.text();
                            return result;
                        case 400:
                            return result;
                        case 403:
                            this.imageAccessible = false
                            return result
                        case 202:
                        case 404:
                            break;
                        default:
                            console.log("Unhandled status code: ", status);
                            break;
                    }

                    await sleep(this.initialRetryDelay + this.delayIncrement * this.retryCount++);
                }

                this.layout.waitForImageElapsed = true;
                return result
            },
            async loadButton() {
                this.layout.buttonLoading = true;
                const response = await APIService.GET(this.getOnedayEndpoint)
                if (!response.ok) {
                    this.layout.buttonLoading = false;
                } else {
                    this.oneDayGalleryUrl = await response.text();
                }
            },
            getDeviceNumberFromFileName(filename) {
                const underscoreIndex = filename.indexOf('_');
                const extractedString = filename.substring(0, underscoreIndex);
                return parseInt(extractedString, 10);
            }
        },
        beforeDestroy() {
            this.pollingEnabled = false
        },
        async mounted() {
            this.checksum = this.$route.query.checksum;
            if (!this.checksum) {
                this.navigateHome()
                return
            }

            if (!this.showEmailCaptureBox) {
                this.originalUrl = await this.loadImage();
                this.layout.showPicture = this.originalImageAvailable;
                this.layout.loading = false;

                if (+this.$route.params.onedaybutton === 1) {
                    await this.loadButton();
                }

                if (this.originalImageAvailable && this.deviceNumber >= 999) {
                    let pollingCount = 0;
                    while (this.pollingEnabled && pollingCount++ < 30) {
                        if (!this.boomerangAvailable) {
                            this.boomerangUrl = await this.loadImage('boomerang');
                        }

                        if (!this.gifAvailable && this.boomerangAvailable) {
                            this.gifUrl = await this.loadImage('gif');
                        }

                        if (!this.gifAvailable || !this.boomerangAvailable) {
                            await sleep(2000);
                        }
                    }
                }
            }
        }
    }
</script>

<style>
</style>